import OrderDTO from "@/dto/order/OrderDTO";
import OrderStatus from "@/enum/OrderStatus";
import { post } from "@/services/http/platformServer";

export enum OrderSyncProgressStatus {
    COMPLETED = "COMPLETED",
    RUNNING = "RUNNING",
}

export interface OrderSyncProgress {
    completedTime: string;
    lastSyncOrderTime: string;
    shopId: number;
    status: OrderSyncProgressStatus;
    message?: string;
}

const syncIncrementally = (shopId: number, config?: any) => {
    const params = { shopId };

    return post<OrderSyncProgress>(shopId, "/order/sync/incrementally", params, config);
};

interface SupplierIncrementally {
    /** 代理商店铺ID */
    shopId: number;
    /** 供货商店铺ID */
    supplierShopId: number;
}

export const supplierIncrementally = (params: SupplierIncrementally): Promise<OrderSyncProgress> => {
    return post<OrderSyncProgress>(params.supplierShopId, "/order/sync/incrementally", params);
};

export const stopSyncIncrementally = (shopId: any) => {
    const params = { shopId };
    return post(shopId, "/order/sync/incrementally/stop", params);
};

const syncByOrderTime = (shopId: number, start: string, end: string, orderStatus?: OrderStatus) => {
    const params = { shopId, start, end, orderStatus };
    return post<OrderSyncProgress>(shopId, "/order/sync/manually", params);
};

const stopSyncByOrderTime = (shopId: any) => {
    const params = { shopId };
    return post(shopId, "/order/sync/manually/stop", params);
};

interface SupplierSyncOrderBytOriginalIds {
    shopId: number;

    originalIds: string;

    supplierShopId: number;
}

export const supplierSyncByOriginalIds = (
    params: SupplierSyncOrderBytOriginalIds,
): Promise<{ successful: boolean }> => {
    return post(params.supplierShopId, "/order/sync/byOriginalIds", params);
};

/**
 * @param originalIds 订单号，多个订单号通过,号分割
 */
const syncByOriginalIds = (shopId: number, originalIds: string) => {
    const data = { shopId, originalIds };
    return post<{ successful: boolean }>(shopId, "/order/sync/byOriginalIds", data);
};

export const resync = (shopId: number, order: OrderDTO, isHistoryOrder: boolean) => {
    const data = {
        shopId,
        orderId: order.id,
        originalId: order.originalId,
        mergeSplitStatus: order.mergeSplitStatus,
        parentOrderId: order.parentId,
        buyerUsername: order.buyerUsername,
        isHistoryOrder,
    };

    return post<{ successful: boolean }>(shopId, "/order/sync/resync", data);
};

export default {
    syncIncrementally,
    stopSyncIncrementally,
    syncByOrderTime,
    stopSyncByOrderTime,
    syncByOriginalIds,
    resync,
};
